import { getSubtotalFromCart } from "../../../commons/functions/generalFunctions";
import {
  validateOnlyLetters,
  validatePhone,
  errorMsgs,
} from "../../../commons/functions/formValidations";

const getTotalUSD = ({
  currencySelect,
  shippingCost,
  applyShippingCost,
  discount,
  customizationCostUSD,
  cart,
}) => {
  let total = 0;
  if (currencySelect && !currencySelect.loading) {
    const valueCurrencyLayer = currencySelect.currency
      ? currencySelect?.currency?.currencyLayer?.data?.value
        ? currencySelect?.currency?.currencyLayer?.data?.value
        : 0
      : 0;
    if (applyShippingCost) {
      total = parseFloat(
        (
          Math.round(
            (getSubtotalFromCart(
              cart,
              "USD",
              currencySelect.currency.currencyLayer &&
                currencySelect.currency.currencyLayer.data.value
            ) +
              getSubtotalFromCart(
                cart,
                "USD",
                currencySelect.currency.currencyLayer &&
                  currencySelect.currency.currencyLayer.data.value
              ) *
                discount +
              customizationCostUSD +
              shippingCost / valueCurrencyLayer) *
              100
          ) / 100
        ).toFixed(2)
      );
    } else {
      total = parseFloat(
        Math.round(
          (getSubtotalFromCart(
            cart,
            "USD",
            currencySelect.currency.currencyLayer &&
              currencySelect.currency.currencyLayer.data.value
          ) +
            customizationCostUSD +
            getSubtotalFromCart(
              cart,
              "USD",
              currencySelect.currency.currencyLayer &&
                currencySelect.currency.currencyLayer.data.value
            ) *
              discount) *
            100
        ) / 100
      ).toFixed(2);
    }
  }
  return total;
};

const getSubTotal = ({ currencySelect, cart }) => {
  if (currencySelect && currencySelect.currency && !currencySelect.loading) {
    return parseFloat(
      getSubtotalFromCart(
        cart,
        "HNL",
        currencySelect.currency.currencyLayer
          ? currencySelect.currency.currencyLayer.data.value
          : 0
      )
    );
  }
};

const getUsdSubTotal = ({ currencySelect, cart }) => {
  if (currencySelect && currencySelect.currency && !currencySelect.loading) {
    return parseFloat(
      getSubtotalFromCart(
        cart,
        "USD",
        currencySelect.currency.currencyLayer
          ? currencySelect.currency.currencyLayer.data.value
          : 0
      )
    );
  }
};

const getTotal = ({
  shippingCost,
  currencySelect,
  applyShippingCost,
  discount,
  customizationCost,
  cart,
}) => {
  let total = 0;
  if (currencySelect && !currencySelect.loading) {
    total = (
      Math.round(
        (getSubTotal({ currencySelect, cart }) +
          getSubTotal({ currencySelect, cart }) * discount +
          customizationCost +
          shippingCost) *
          100
      ) / 100
    ).toFixed(2);
  }

  return total;
};

const getUsdTotal = ({
  shippingCost,
  currencySelect,
  applyShippingCost,
  discount,
  customizationCost,
  cart,
}) => {
  let total = 0;
  if (currencySelect && !currencySelect.loading) {
    total = (
      Math.round(
        (getUsdSubTotal({ currencySelect, cart }) +
          getSubTotal({ currencySelect, cart }) * discount +
          customizationCost +
          shippingCost / currencySelect?.currency?.currencyLayer?.data?.value) *
          100
      ) / 100
    ).toFixed(2);
  }

  return total;
};

const getCustomizationCost = ({ cart, customizationCost }) => {
  let value = 0;
  cart.forEach((element) => {
    if (element.customText.length > 0) {
      value = value + element.quantity;
    }
  });
  return value * customizationCost;
};

const validateCardForm = ({ e, setCardDetails, cardInfo }) => {
  const { name, value } = e.target;
  switch (name) {
    case "cardName":
      validateOnlyLetters(value)
        ? setCardDetails({
            ...cardInfo,
            [name]: { value: value.toString().toUpperCase(), error: "" },
          })
        : value === ""
        ? setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.required },
          })
        : value.length === 1
        ? setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.atLeastTwo },
          })
        : setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.lettersOnly },
          });
      break;
    case "cardNumber":
    case "cardExpiryDate":
      validatePhone(value)
        ? value.toString().length <= 16 &&
          setCardDetails({
            ...cardInfo,
            [name]: { value: value.toString(), error: "" },
          })
        : value === ""
        ? setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.required },
          })
        : value.length === 1
        ? setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.atLeastTwo },
          })
        : setCardDetails({
            ...cardInfo,
            [name]: {
              value: value.toString(),
              error: /*errorMsgs.numbersOnly */ "",
            },
          });
      break;

    case "cardCVV2":
      validatePhone(value)
        ? value.toString().length <= 4 &&
          setCardDetails({
            ...cardInfo,
            [name]: { value: value.toString(), error: "" },
          })
        : value === ""
        ? setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.required },
          })
        : setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.numbersOnly },
          });
      break;
    default:
      value !== ""
        ? setCardDetails({
            ...cardInfo,
            [name]: { value: value.toString(), error: "" },
          })
        : setCardDetails({
            ...cardInfo,
            [name]: { value, error: errorMsgs.required },
          });
      break;
  }
};

export {
  getTotalUSD,
  getSubTotal,
  getTotal,
  getCustomizationCost,
  validateCardForm,
  getUsdTotal,
  getUsdSubTotal,
};
